import { Box, Code, CopyButton, ActionIcon, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy, IconExternalLink } from '@tabler/icons';
import { FC } from 'react';
import { RoutingS } from '../Service/RoutingS';

interface Props {
  content: string;
  includeOpenLinkIcon?: boolean;
}

const CodeWithCopy: FC<Props> = ({ content, includeOpenLinkIcon }) => (
  <Box pos="relative">
    <Code block>
      {content}
      <Box sx={{ position: 'absolute', right: 5, top: 5 }}>
        <Box sx={{ display: 'flex', gap: 5 }}>
          <CopyButton value={content} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Kopiert' : 'Kopieren'} withArrow position="right">
                <ActionIcon color={copied ? 'teal' : 'gray'} onClick={copy}>
                  {copied ? <IconCheck size="1rem" /> : <IconCopy size="1rem" />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
          {includeOpenLinkIcon && (
            <Tooltip label="Link öffnen" withArrow position="right">
              <ActionIcon color="gray" onClick={() => RoutingS.openInNewTab(content)}>
                <IconExternalLink size="1rem" />
              </ActionIcon>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Code>
  </Box>
);

export default CodeWithCopy;
